import { render, staticRenderFns } from "./GrafanaDashboard.vue?vue&type=template&id=0428510c&scoped=true&"
import script from "./GrafanaDashboard.vue?vue&type=script&lang=js&"
export * from "./GrafanaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GrafanaDashboard.vue?vue&type=style&index=0&id=0428510c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428510c",
  null
  
)

export default component.exports